<template>
  <!-- <div>changeUnitModal - {{ this.item }}</div> -->
  <div class="custom-unit-modal">
    <div class="custom-backdrop"></div>
    <div class="modal-content-main">
      <div class="modal-content-wrap">
        <div class="overlay aligned-center" v-if="isLoading">
          <div class="overlay-content">
            <LoadingSpinner :loadingCaption="loadingCaption" />
            <div class="button-text">
              <!-- Here could be a button to close task after loading finished -->
            </div>
          </div>
        </div>
        <div class="close-modal" @click="closeModal()">
          <i class="fab fa-times"></i>
        </div>
        <div class="content-title">
          <h4>Wie soll mit der Einheit umgegangen werden ?</h4>
        </div>
        <div class="content-wrap">
          <div class="set-unit-list">
            <ul>
              <li @click="reInterpretUnit()">
                <h6>Einheit überschreiben</h6>

                <div class="description">
                  <p>Einheit wird korrigiert ohne Änderungen an den Werten.</p>
                </div>
              </li>
              <li @click="convertLoad()">
                <h6>Lastgang konvertieren</h6>
                <div class="description">
                  <p>
                    Werte werden zu der neu ausgewählten Einheit konvertiert.
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
export default {
  data() {
    return {
      loadingCaption: null,
    };
  },
  props: {
    item: Object,
    isLoading: Boolean,
  },
  methods: {
    closeModal() {
      this.$emit('closeUnitModal');
    },
    reInterpretUnit() {
      this.loadingCaption = 'Einheit wird Angepasst...';
      this.$emit('reInterpretUnit');
    },
    convertLoad() {
      this.loadingCaption = 'Lastgang wird konvertiert...';
      this.$emit('convertLoad');
    },
  },
  components: {
    LoadingSpinner,
  },
};
</script>
<style scoped>
.custom-backdrop {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  left: 0;
  top: 0;
}
.customdropzone .list.dz-preview .dz-details div.custom-unit-modal {
  zoom: 1.35;
}
.customdropzone .list.dz-preview .dz-details div.custom-unit-modal,
.custom-unit-modal {
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  margin: 0;
  padding: 0;
  overflow: unset;
  width: 100%;
  height: 100%;
  max-width: 100%;
  z-index: 9;
}

.modal-content-main {
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  position: relative;
  font-family: 'Open Sans', open-sans, sans-serif;
}

.modal-content-wrap {
  background: #fff;
  width: 100%;
  max-width: 600px;
  border-radius: 4px;
  height: 350px;
  overflow: auto;
  text-align: center;
  position: relative;
}
.close-modal {
  position: absolute;
  background-image: url(/img/modal-sprite.67649c98.png);
  background-size: 1293px 1277px;
  background-position: -1278px -577px;
  right: 0;
  border: none;
  display: block;
  width: 25px;
  height: 25px;
  background-color: white;
  top: 10px;
  padding: 0 0;
  cursor: pointer;
  z-index: 2;
}
.content-title h4 {
  padding: 35px 0 20px;
  font-size: 22px;
  font-weight: 700;
  color: #333;
  margin-bottom: 0;
  text-align: center;
  font-family: inherit;
}
.overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
}
.overlay::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.7;
  z-index: -1;
}
.aligned-center {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

::v-deep .modal-content-wrap .progress-icon:after {
  border-color: #fff transparent;
  color: #fff;
}

::v-deep .modal-content-wrap .loading {
  position: unset;
  color: #fff;
}

.modal-content-wrap .loading {
  min-height: 35px;
  background: transparent;
}

.modal-content-wrap .progress-icon-wrapper {
  bottom: 0;
}

.modal-content-wrap button {
  padding: 0px 20px;
  margin: 0;
  border-radius: 4px;
}
.set-unit-list ul {
  list-style: none;
  margin: 0 auto;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.set-unit-list ul li {
  padding: 25px 15px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  border: 1px solid rgb(34 69 133 / 5%);
  border-radius: 4px;
  background: rgb(34 69 133 / 5%);
  margin-bottom: 10px;
  cursor: pointer;
}

.set-unit-list ul li h6 {
  font-size: 16px;
  color: #262626;
  text-align: center;
  font-weight: 600;
}
.modal-content-wrap .content-wrap {
  height: calc(100% - 96px);
}

.modal-content-wrap .set-unit-list {
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
